import type { LetterHead, Meeting, Team, Tenant } from "@repo/types";
import { PDFViewer } from "@react-pdf/renderer";
import { AgendaDocument } from "@repo/ui/components/Base/AgendaDocument";
import { cn } from "@repo/shared/utils";
import { useState } from "react";
import { config } from "@/config";

interface AgendaPreviewProps {
  showToolbar?: boolean;
  tenant?: Tenant;
  meeting?: Meeting;
  team?: Team;
  letterHead?: LetterHead;
  enableLinks?: boolean | "all";
  substituteLinkMap?: Record<string, string>;
  augmented?: boolean;
  className?: string;
}
export const AgendaPreview = ({
  tenant,
  meeting,
  team,
  letterHead,
  showToolbar,
  enableLinks = true,
  substituteLinkMap,
  augmented = false,
  className,
}: AgendaPreviewProps) => {
  // Memorize and keep initial props
  // This prevents binding errors that occur due to too many renders
  // Use a new key on <AgendaPreview> to trigger actual refresh
  const [document] = useState(
    <AgendaDocument
      tenant={tenant}
      meeting={meeting}
      team={team}
      letterHead={letterHead}
      enableLinks={enableLinks}
      apiUrl={config.urls.api}
      substituteLinkMap={substituteLinkMap}
      augmented={augmented}
      numberFormat={tenant?.numberFormat}
    />
  );

  return (
    <PDFViewer
      className={cn("w-full h-full", className)}
      showToolbar={showToolbar}
    >
      {document}
    </PDFViewer>
  );
};
